import { useEffect, type ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { Icone } from './Icone'

/**
 * Panneau latéral (fiche client). Même contrat que `Modale` — portail vers `document.body` (sans lui, la
 * règle `[data-anim]` des cartes en ferait le bloc conteneur du `position: fixed` : le panneau s'ouvrirait
 * à la taille de la carte), Échap ferme, un clic sur le fond ferme — mais il se pose à droite et garde la
 * liste visible derrière lui.
 */
export function PanneauLateral({
  titre,
  sousTitre,
  surFermer,
  children,
}: {
  titre: string
  sousTitre?: ReactNode
  surFermer: () => void
  children: ReactNode
}) {
  useEffect(() => {
    const h = (e: KeyboardEvent) => e.key === 'Escape' && surFermer()
    document.addEventListener('keydown', h)
    return () => document.removeEventListener('keydown', h)
  }, [surFermer])

  return createPortal(
    <div className="panneau-fond on" onClick={(e) => e.target === e.currentTarget && surFermer()}>
      <aside className="panneau" role="dialog" aria-modal="true" aria-label={titre}>
        <div className="panneau-tete">
          <div style={{ flex: 1, minWidth: 0 }}>
            <h3>{titre}</h3>
            {sousTitre && <div className="t-muted" style={{ fontSize: 12.5 }}>{sousTitre}</div>}
          </div>
          <button className="btn btn-ghost btn-sm" onClick={surFermer} aria-label="Fermer la fiche" title="Fermer">
            <Icone nom="x" />
          </button>
        </div>
        <div className="panneau-corps">{children}</div>
      </aside>
    </div>,
    document.body,
  )
}
